import { render } from "./editarAsignacion.vue?vue&type=template&id=6b155b48&scoped=true"
import script from "./editarAsignacion.vue?vue&type=script&lang=js"
export * from "./editarAsignacion.vue?vue&type=script&lang=js"

import "./editarAsignacion.vue?vue&type=style&index=0&id=6b155b48&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b155b48"]])

export default __exports__